import React from 'react'
import { Flex, Segmented, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Configuration, PreviewAppearance } from '../public-form'
import { PublicFormPage } from './public-form-page'

export function BrandingPreview({
    value,
    activeAppearance,
    device,
    onDeviceChange,
}: {
    value: Configuration
    activeAppearance: PreviewAppearance
    device: string
    onDeviceChange: (device: string) => void
}) {
    const { t } = useTranslation()
    return (
        <>
            <Flex
                justify="space-between"
                align="center"
                wrap
                gap="small"
                className="mb-3"
            >
                <Typography.Text strong>{t('Live preview')}</Typography.Text>
                <Segmented
                    value={device}
                    onChange={onDeviceChange}
                    options={[
                        { value: 'Desktop', label: t('Desktop') },
                        { value: 'Mobile', label: t('Mobile') },
                    ]}
                />
            </Flex>
            <Typography.Paragraph type="secondary">
                {t('{{device}} preview · {{size}} px', {
                    device: t(device),
                    size: device === 'Mobile' ? 375 : 640,
                })}
            </Typography.Paragraph>
            <div className="public-form-preview-scroll">
                <div
                    className="public-form-preview-frame"
                    style={{ width: device === 'Mobile' ? 375 : 640 }}
                >
                    <PublicFormPage
                        configuration={value}
                        previewAppearance={activeAppearance}
                        preview
                    />
                </div>
            </div>
            <Typography.Paragraph
                type="secondary"
                className="mt-3"
            >
                {t('Preview only. Submitting here does not create a candidate or send a message.')}
            </Typography.Paragraph>{' '}
        </>
    )
}
